export enum DimensionamentoTipo {
  SUFICIENTE = 'SUFICIENTE',
  INSUFICIENTE = 'INSUFICIENTE',
}
